









































import Vue from 'vue'
import RegistroAsistencia from '../components/RegistroAsistenica.vue'
import Swal from 'sweetalert2'
import API from '../services/api'
import { ParticipantResult } from '../services/participante'
import { eventoService } from '../services/evento'

export interface AsistenciaComponentData {
  valid: boolean
  dni: null | string | number
  dniRules: any[]
  mostrar: boolean
  evento: any | null
  id_evento: any
}

export default Vue.extend({
  components: {
    RegistroAsistencia,
  },

  data(): AsistenciaComponentData {
    return {
      valid: false,
      dni: '',
      dniRules: [
        (v: any) => /^([0-9])*$/.test(v) || 'Solo puede ingresar números',
        (v: any) => !!v || 'Identificación requerida',
      ],
      mostrar: false,
      evento: null,
      id_evento: '',
    }
  },
  methods: {
    async submit(e: any) {
      e.preventDefault()
      if ((this as any).valid) {
        (this as any).search()
      }
    },

    ocultar(e: any) {
      (this as any).mostrar = e
    },

    search() {
      API.getRequest(`/participante/${(this as any).dni}`)
        .then(resp => {
          const data = resp.data
          if (data) {
            Swal.fire({
              title: '<strong>Registro de asistencia para:</strong>',
              icon: 'warning',
              html:
                '<h2><u>' +
                data.nombres.toUpperCase() +
                ' ' +
                data.apellidos.toUpperCase() +
                '</h2></u>',
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false,
              confirmButtonText: '<i class="fa fa-thumbs-up"></i> Aceptar!',
              cancelButtonText: 'Cancelar',
            }).then(async result => {
              if (result.isConfirmed) {
                try {
                  const response = await eventoService.Asistencia({
                    id_evento: (this as any).id_evento,
                    id_participante: data.id_participante,
                  })
                  if (response.ok) {
                    Swal.fire(
                      'Éxito',
                      'Registro de asistencia exitoso',
                      'success'
                    ).then(result => {
                      location.href = (this as any).evento.url
                    })
                  }
                  if (response.error) {
                    Swal.fire(
                      'Error',
                      'ups!!, ha ocurrido un error, ' + response.error,
                      'error'
                    )
                  }
                } catch (error) {
                  Swal.fire(
                    'Error',
                    'ups!!, ha ocurrido un error, Usted ya registro asistencia anteriormente',
                    'error'
                  )
                }
              }
            })
          } else {
            (this as any).mostrar = true
          }
        })
        .catch(error => {
          Swal.fire('Error', 'ups!!, ha ocurrido un error', 'error')
        })
    },
  },

  async mounted() {
    (this as any).id_evento = (this as any).$route.params.id_evento
    const response = await eventoService.getEvento((this as any).id_evento)
    if (!response) {
      location.href = 'http://isistemas.umariana.edu.co/expo'
      return
    }

    if (response) {
      (this as any).evento = response
    }

    if (response.error) {
      Swal.fire(
        'Error',
        'ups!!, ha ocurrido un error, ' + response.error,
        'error'
      ).then(() => {
        location.href = 'http://isistemas.umariana.edu.co/expo'
      })
    }
  },
})
